module.exports = __webpack_public_path__ + "static/media/MovieRouletteSwift.b50c98d5.png";